import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import {
  AllPatientDispatchTypes,
  PatientHeaderDispatchTypes,
} from "../models/DispatchTypes/AllPatientRecord";
import { PatientRecordDispatchTypes } from "../constants/AllPatientRecords";
import { ApplicationState } from "../store/ApplicationState";
import { GetPatientHeader, PostAllPatientRecord } from "../services/AllPatientRecord";
import { baseUrl } from "../constants/Config";
import { PatientHeaderActionDispatchTypes } from "../constants/Patient";
import { SearchPayloadForRecords } from "../models/Authorization";

export const postAllPatientRecord: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AllPatientDispatchTypes
  >
> = (payload: SearchPayloadForRecords) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PatientRecordDispatchTypes.POST_PATIENT_RECORD_INVOKE,
    });

    const response = await PostAllPatientRecord(baseUrl, payload);

    dispatch({
      response: response,
      type: PatientRecordDispatchTypes.POST_PATIENT_RECORD_SUCCESS,
    });
  };
};

export const getPatientHeader: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PatientHeaderDispatchTypes
  >
> = (patientId: number, referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PatientHeaderActionDispatchTypes.GET_PATIENT_HEADER_INVOKE,
    });

    const response = await GetPatientHeader(
      baseUrl,
      patientId,
      referralId,
    );

    dispatch({
      response: response,
      type: PatientHeaderActionDispatchTypes.GET_PATIENT_HEADER_SUCCESS,
    });
  };
};
